import { OrganizationKeyName } from "../../../model/Organization";

export const UPSERT_ORGANIZATION = "ORGANIZATION:UPSERT_ORGANIZATION";

export const upsertOrganizationAction = (
  data: any,
  organizationKeyName?: OrganizationKeyName
) => ({
  type: UPSERT_ORGANIZATION as typeof UPSERT_ORGANIZATION,
  data,
  organizationKeyName,
});

export type UpsertOrganizationAction = ReturnType<
  typeof upsertOrganizationAction
>;
